module.exports = __webpack_public_path__ + "static/img/guideline2024.85721cb.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guideline2024.pdf
// module id = rjUm
// module chunks = 62